<mat-card style="padding: 0.5in;">
	<!-- <mat-card-header> -->

	<div class="row" style="margin-bottom: 20px;">
		<div class="col-sm-6" style="text-align: left;">
			<button mat-raised-button (click)="closeDialog()">
				<mat-icon>close</mat-icon>
				Close
			</button>
		</div>
		<div class="col-sm-6" style="text-align: right;">
			<button mat-raised-button color="primary" (click)="printReport()">
				<mat-icon>print</mat-icon>
				Print Report
			</button>
		</div>
	</div>

	<!-- </mat-card-header> -->
	<mat-card-content>

		<kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="0.25in">

			<div class="row">
				<div class="col-sm-12" style="text-align:center">
					<span style="font-size: 15pt"><strong>Failed or Missing PTs</strong></span>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12" style="text-align:center">
					<span style="font-size: larger">{{labApp.laboratoryName}}</span>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12" style="text-align:center">
					<span style="font-size: larger">{{labApp.orelapId}}</span>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12" style="text-align:center">
					<span style="font-size: larger">{{fromDate}} - {{toDate}}</span>
				</div>
			</div>
			
			<div class="row" style="margin-top: 5pt">
				<div class="col-sm-12">
					<table id="tblAnalytes" class="table table-condensed table-striped">
						<thead>
							<tr>
								<th style="width: 3%;">No.</th>
								<th style="width: 8%;">Matrix</th>
								<th style="width: 8%;">Technology</th>
								<th style="width: 4%;">Method Code</th>
								<th style="width: 10%;">Method</th>
								<th style="width: 5%;">Analyte Code</th>
								<th style="width: 10%;">Analyte</th>
								<th *ngFor="let item of [].constructor(numberOfColumns); let i = index" style="width: 6;"></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let pts of viewList; let i = index">
								<tr>
									<td>{{i + 1}}</td>
									<td>{{pts.matrix}}</td>
									<td>{{pts.technology}}</td>
									<td>{{pts.methodCode}}</td>
									<td>{{pts.methodDesc}}</td>
									<td>{{pts.analyteCode}}</td>
									<td *ngIf="pts.analyte == PT_NOT_FOUND_ON_APP" style="color:red;">{{pts.analyte}}
									</td>
									<td *ngIf="pts.analyte != PT_NOT_FOUND_ON_APP">{{pts.analyte}}</td>
									<ng-container *ngFor="let result of pts.results">
										<td *ngIf="result.result.toUpperCase() != 'ACCEPT.'" class="alert alert-warning"
											style="text-align:center">
											{{result.result}}
											<br />
											<sup>
												{{result.closeDate | date:'MM/dd/yyyy'}}
											</sup>
										</td>
										<td *ngIf="result.result.toUpperCase() === 'ACCEPT.'" style="text-align:center">
											{{result.result}}
											<br />
											<sup>
												{{result.closeDate | date:'MM/dd/yyyy'}}
											</sup>
										</td>
									</ng-container>
								</tr>
							</ng-container>

						</tbody>
					</table>
				</div>
			</div>

			<!-- <div class="row" style="margin-top: 5pt">
				<div class="col-sm-12">
					<table id="tblAnalytes" class="table table-condensed table-striped">
						<thead>
							<tr>
								<th>Matrix</th>
								<th>Technology</th>
								<th>Method Code</th>
								<th>Method</th>
								<th>Analyte Code</th>
								<th>Analyte</th>
								<th></th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td>@analyte.Matrix</td>
								<td>@analyte.Technology</td>
								<td>@analyte.MethodCode</td>
								<td>@analyte.MethodDesc</td>
								<td>@analyte.AnalyteCode</td>
								<td class="alert alert-warning">@analyte.Analyte</td>
								<td class="alert alert-warning" style="text-align:center">
									<br />
									<sup>
									</sup>
								</td>
								<td style="text-align:center">
									<br />
									<sup>
									</sup>
								</td>

								<td>------</td>

							</tr>
						</tbody>
					</table>
				</div>
			</div> -->

		</kendo-pdf-export>
	</mat-card-content>
</mat-card>